export const Routes = {
  index: '/',
  auth: {
    index: '/auth',
    sign_up: '/auth/sign-up',
    sign_in: '/auth/sign-in',
    sign_in_step_2: '/auth/sign-in/step-2',
    forgot_password: '/auth/forgot-password',
    reset_password: '/auth/reset-password',
    confirm_user: '/auth/confirm',
    successfully_logged_in: '/auth/successfully-logged-in',
  },
  roadmap: {
    index: '/roadmap',
  },
  uiKit: {
    index: '/ui-kit',
  },
  devKit: {
    index: '/dev-kit',
  },
  sample: {
    index: '/sample',
  },
} as const;
